import type { SelectSize } from 'ui/select/select.types';

export const SELECT_DEFAULT_PLACEHOLDER = 'Select...';

export const SELECT_TAG_INPUT_PLACEHOLDER = 'Type...';

export const SELECT_DEFAULT_TEST_ID = 'select-field';

export const SELECT_SELECTED_PREFIX = 'Selected: ';

export const SELECT_CREATE_OPTION_KEY_PREFIX = 'create:';

export const SELECT_TAG_CREATE_KEYS: ReadonlySet<string> = new Set([
  'Enter',
  'Tab',
  ' ',
]);

export const SELECT_MULTI_INSET_PX = 4;

export const SELECT_VALUE_GAP_PX = 4;

export const SELECT_TRAILING_GAP_PX = 6;

export const SELECT_DIVIDER_WIDTH_PX = 1;

export const SELECT_ICON_TARGET_PX = 24;

export const SELECT_CHIP_BORDER_PX = 1;

interface SelectChipGeometry {
  paddingX: number;
  paddingY: number;
  gap: number;
  radius: number;
  icon: number;
}

export const SELECT_CHIP_GEOMETRY = {
  large: { paddingX: 10, paddingY: 6, gap: 4, radius: 6, icon: 16 },
  medium: { paddingX: 8, paddingY: 4, gap: 4, radius: 4, icon: 14 },
} as const satisfies Record<SelectSize, SelectChipGeometry>;
